export const DEBOUNCE_DELAY_MS = 250

export const MIN_OFFER_SIZE = 1000

export const MIN_SLIDER_PERCENT = 10
export const MAX_SLIDER_PERCENT = 100
